import React, { useState } from "react";

export default function MultiSelectCheck({ listItems, itemLabel, itemId, title, selectedItems, setSelectedItems }) {
    const [isAllSelected, setIsAllSelected] = useState(false)

    const handleChangeCheck = (id) => {
        setIsAllSelected(false)
        if (isChecked(id)) {
            setSelectedItems(selectedItems.filter((x) => x !== id))
        } else {
            let newSelects = [...selectedItems]
            newSelects.push(id)
            setSelectedItems(newSelects)
        }
    }

    const isChecked = (id) => {
        let selects = selectedItems.filter((x) => x == id)
        return selects.length > 0
    }

    const selectAll = () => {
        if (selectedItems.length > 0) {
            setIsAllSelected(false)
            setSelectedItems([])
        } else {
            setIsAllSelected(true)
            let allSelect = []
            listItems.map(x => allSelect.push(x[itemId]))
            setSelectedItems(allSelect)
        }
    }

    return (
        <div className="card border">
            <div className="border-bottom py-2 px-4 d-flex justify-content-between align-items-center">
                <div className="text-primary">{title}</div>
                <div className="d-flex justify-content-start align-items-center">
                    <label className="form-check-label text-primary" style={{ marginRight: 5 }}>Selecionar Todos</label>
                    <input className="form-check-input" type="checkbox" onChange={() => selectAll()} checked={isAllSelected} />
                </div>
            </div>
            <div className="py-2 px-4" style={{ height: 120, overflowY: 'scroll' }}>
                <div className="row">
                    {Array.isArray(listItems) && listItems.length > 0 ? (
                        listItems.map((item, index) => (
                            <div className="col-4 py-1" key={index}>
                                <div className="d-flex justify-content-start align-items-center">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        onChange={() => handleChangeCheck(item[itemId])}
                                        checked={isChecked(item[itemId])}
                                    />
                                    <label className="form-check-label" style={{ fontSize: 12, marginLeft: 5 }}>
                                        {item[itemLabel]}
                                    </label>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="col-12 text-center text-muted">
                            Nenhum item para este grupo
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};